import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IWorkloadInitialState, IWorkloadPayload } from "../types";
import { GetItemWorkload, GetWorkload, GetWorkloadNorms } from "../store/thunk";
import { EStatus, IBaselinePayload } from "@pages/LearningManagement/Baseline/types";

const initialState: IWorkloadInitialState = {
    workloadData: [],
    isLoadingWorkload: true,
    selectedWorkloadID: [],
    isWorkloadRestore: false,
    workloadRestoreData: [],
    workloadItem: {
        id: 0,
        status: EStatus.confirmed,
        workload_subjects: [],
        academic_department_id: 0,
        educational_degree_id: 0,
        academic_year_id: 0,
        subject_check_types: [],
    },
    isLoadingWorkloadItems: true,
    isLoadingTeachingLoad: true,
    teachingLoad: [],
};

const workloadSlice = createSlice({
    name: "workload",
    initialState,
    reducers: {
        setWorkloadData: (state, action: PayloadAction<IWorkloadPayload[]>) => {
            state.workloadData = action.payload;
        },
        setSelectedWorkloadIDs: (state, action) => {
            state.selectedWorkloadID = action.payload;
        },
        updateWorkload: (state, action: PayloadAction<IBaselinePayload>) => {
            state.workloadData = state.workloadData.map(elem =>
                elem.id === action.payload.id ? { ...elem, ...action.payload } : elem
            );
        },
        deletedWorkload: (state, action: PayloadAction<number>) => {
            state.workloadData = state.workloadData.filter(elem => elem.id !== action.payload);
        },
        setIsRestoreWorkload: state => {
            state.isWorkloadRestore = !state.isWorkloadRestore;
        },
        deletedRestoreWorkload: (state, action) => {
            state.workloadRestoreData = state.workloadRestoreData.filter(elem => elem.id !== action.payload);
        },
        setRestoreWorkload: (state, action) => {
            state.workloadRestoreData = action.payload;
        },
        setItemWorkload: (state, action) => {
            state.workloadItem = action.payload;
        },
        setTeachingLoad: (state, action) => {
            state.teachingLoad = action.payload;
        },
    },
    extraReducers: builder => {
        builder
            .addCase(GetWorkload.pending, state => {
                state.isLoadingWorkload = true;
            })
            .addCase(GetWorkload.fulfilled, state => {
                state.isLoadingWorkload = false;
            })
            .addCase(GetWorkload.rejected, state => {
                state.isLoadingWorkload = false;
            })
            .addCase(GetItemWorkload.pending, state => {
                state.isLoadingWorkloadItems = true;
            })
            .addCase(GetItemWorkload.fulfilled, state => {
                state.isLoadingWorkloadItems = false;
            })
            .addCase(GetItemWorkload.rejected, state => {
                state.isLoadingWorkloadItems = false;
            })

            .addCase(GetWorkloadNorms.pending, state => {
                state.isLoadingTeachingLoad = true;
            })
            .addCase(GetWorkloadNorms.fulfilled, state => {
                state.isLoadingTeachingLoad = false;
            })
            .addCase(GetWorkloadNorms.rejected, state => {
                state.isLoadingTeachingLoad = false;
            });
    },
});

export const {
    setWorkloadData,
    setSelectedWorkloadIDs,
    updateWorkload,
    deletedWorkload,
    setRestoreWorkload,
    deletedRestoreWorkload,
    setIsRestoreWorkload,
    setItemWorkload,
    setTeachingLoad,
} = workloadSlice.actions;

export default workloadSlice;
